// removed by extract-text-webpack-plugin
module.exports = {"container":"_3JwseeMg8sUwxi7RSga0ea"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Admin/OrganizationsData/styles.css
// module id = 3176
// module chunks = 0